import { getValueOrDefault } from '../../components/values/Get';
import { isCustomerAllowedToSelectWorkshop } from '../../helpers/business-rules/isCustomerAllowedToSelectWorkshop';
import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getWorkshopDetails } from '../shared/vehicle';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'dato';
            break;
        case 'dato':
            nextPage = 'tidspunkt';
            break;
        case 'tidspunkt':
            nextPage = 'adresse';
            break;
        case 'adresse':
            nextPage = 'beskriv-skaden';
            break;
        case 'beskriv-skaden':
            nextPage = 'koeretoej-nummerplade';
            break;
        case 'koeretoej-nummerplade':
            nextPage = 'hvilket-koeretoej';
            break;
        case 'hvilket-koeretoej':
            if (getValueOrDefault(formConfig, formValues, 'vehicleTypeOther').value === 'other') {
                nextPage = 'skader-andet-koeretoej';
            } else {
                nextPage = 'skadezoner';
            }
            break;
        case 'skader-andet-koeretoej':
            nextPage = 'informationer-om-modpart';
            break;
        case 'skadezoner':
            nextPage = 'informationer-om-modpart';
            break;
        case 'informationer-om-modpart':
            if (getValueOrDefault(formConfig, formValues, 'informationAboutCounterpart').value === 'yes') {
                nextPage = 'om-modparten';
            } else {
                nextPage = 'dokumentation';
            }
            break;
        case 'om-modparten':
            nextPage = 'dokumentation';
            break;
        case 'dokumentation':
            if (getValueOrDefault(formConfig, formValues, 'informationAboutCounterpart').value === 'yes') {
                nextPage = 'politi';
            } else if (isCustomerAllowedToSelectWorkshop(getWorkshopDetails(formConfig, formValues), 'cvr')) {
                nextPage = 'find-vaerksted';
            } else {
                nextPage = 'virksomhedsoplysninger';
            }
            break;
        case 'politi':
            if (isCustomerAllowedToSelectWorkshop(getWorkshopDetails(formConfig, formValues), 'cvr')) {
                nextPage = 'find-vaerksted';
            } else {
                nextPage = 'virksomhedsoplysninger';
            }
            break;
        case 'find-vaerksted':
            nextPage = 'virksomhedsoplysninger';
            break;
        case 'virksomhedsoplysninger':
            nextPage = 'om-virksomheden';
            break;
        case 'om-virksomheden':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;
        case 'resume':
            nextPage = undefined;
            break;
        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
